import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    nombreFlujo: { label: i18n.t('app.name'), value: '' },
    descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
    fechaCreacionDesde: { label: i18n.t('approval_workflow.creation_date_from'), value: '' },
    fechaCreacionHasta: { label: i18n.t('approval_workflow.creation_date_to'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    {
      field: 'IdCliente',
      width: '100px',
      title: i18n.t('clients.id_client'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'IdFlujoAprobacion', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'Nombre', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Descripcion', title: i18n.t('invoices.invoices_issuing.descripcion'), columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'Activo', title: i18n.t('app.active'), columnMenu: 'myTemplate', cell: 'checkboxTemplate', type: 'boolean', groupable: false, locked: false, width: '110px' },
    { field: 'FechaCreacion', title: i18n.t('approval_workflow.creation_date'), type: 'date', filter: 'date', format: 'numeric_date', cell: 'fechaTemplate', columnMenu: 'myTemplate', width: '200px', locked: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'IdEstadoDestinoFactura', title: i18n.t('approval_workflow.destination_state'), format: 'TIPOS_ESTADO_RECEPCION', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, width: '230px', minWidth: 200, },
    { field: 'Grupos', width: '440px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
